// @flow

import type { Saga } from 'redux-saga';
import { put, call, select } from 'redux-saga/effects';
import { getVerticalId, getCountryCode } from '~/common/selectors/config';
import type { UpdateSearchNotificationAction } from '../types';
import WebPushNotificationsApi from '~/sdk/notifications/webPush/ApiNotifications';
import { updateSearchNotificationSuccess, restoreSearchNotifications } from '../actions';
import { searchNotificationsSelector } from '../selectors';
import { openSnackbarError, closeSnackbar } from '../../Snackbar/actions';
import { subscriptionIdSelector } from '../../Authentication/selectors';
import { trackingCodeByOriginSelector } from '../../selectors';

export default (webPushNotificationsApi: WebPushNotificationsApi) =>
  function* updateSearchNotificationSaga({
    payload: { searchNotification, partialSearchNotification },
  }: UpdateSearchNotificationAction): Saga<void> {
    yield put(closeSnackbar());

    const newSearchNotification = { ...searchNotification, ...partialSearchNotification };
    const searchNotifications = yield select(searchNotificationsSelector);

    const subscriptionId = yield select(subscriptionIdSelector);
    const verticalId = yield select(getVerticalId);
    const countryCode = yield select(getCountryCode);
    const trackingCode = yield select(trackingCodeByOriginSelector);

    // Eager user response with full rollback on error
    yield put(updateSearchNotificationSuccess(newSearchNotification));

    const options = {
      subscriptionId,
      searchNotificationId: newSearchNotification.id,
      enabled: newSearchNotification.active,
      verticalId,
      countryCode,
      trackingCode,
    };

    try {
      yield call(
        [webPushNotificationsApi, webPushNotificationsApi.updateSearchNotification],
        options
      );
    } catch (error) {
      yield put(openSnackbarError());
      yield put(restoreSearchNotifications(searchNotifications));
    }
  };



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/sagas/updateSearchNotification.js